import alertMessageTemplate from './alert_message.template.html';

class WbAlertMessageController {

    constructor($sce) {
        'ngInject';

        const injectables = {
            $sce
        };

        Object.assign(this, injectables);
    }

    $onInit() {
        // Decode the HTML so that HTML is rendered in the alert message
        var txt = document.createElement("textarea");
        txt.innerHTML = this.alert.msg;
        this.trustedHtml = txt.value;
    }
}

const WbAlertMessageComponent = {
    templateUrl: alertMessageTemplate.id,
    controller: WbAlertMessageController,
    controllerAs: '$wbAlertMessageCtrl',
    bindings: {
        alert: '<'
    }
};

angular
    .module('westBerkshireEvents.alertMessage')
    .component('wbAlertMessage', WbAlertMessageComponent);

export default WbAlertMessageController;


// WEBPACK FOOTER //
// ../src/public/javascripts/alert-message/alert_message.component.js